import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { retry, timer } from 'rxjs';

/**
 * Interceptor para reintentar peticiones HTTP fallidas
 * Útil para errores temporales de red o servidor
 */
export const retryInterceptor: HttpInterceptorFn = (req, next) => {
    // Solo reintentar peticiones GET (idempotentes)
    if (req.method === 'GET') {
        return next(req).pipe(
            retry({
                count: 2, // Reintentar hasta 2 veces
                delay: (error, retryCount) => {
                    // Solo reintentar en errores de red o servidor temporal
                    if (error.status === 0 || error.status >= 500) {
                        const delayMs = retryCount * 1000; // 1s, 2s                        
                        return timer(delayMs);
                    }
                    // No reintentar otros errores
                    throw error;
                }
            })
        );
    }

    // No reintentar peticiones POST, PUT, DELETE (no idempotentes)
    return next(req);
};
